var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartRemoteControl = function SvgStartRemoteControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 28"
  }), _title || (_title = /*#__PURE__*/React.createElement("title", null, "play")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.625 14.484.875 26.015c-.484.266-.875.031-.875-.516v-23c0-.547.391-.781.875-.516l20.75 11.531c.484.266.484.703 0 .969z"
  })));
};
export default SvgStartRemoteControl;